import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {useState} from 'react';
import clsx from 'clsx';
import ImageSelector from '@di-shared/features/common/ImageSelector';

function CpoGuide() {
  const {t} = useInferableTranslation();
  return (
    <>
      <section className="section">
        <div className="section_heading type_main">
          <h2
            className="section_heading_title"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20251')}
          </h2>
          <p className="section_heading_desc">{t('T20252')}</p>
        </div>
        <div className="section_visual visual_certification_intro">
          <ImageSelector
            className="section_visual_img"
            alt="certification_image"
            kiaLightSrc={() => import('@di-shared/assets/img/visual/hyundai/certification.png')}
            kiaDarkSrc={() => import('@di-shared/assets/img/visual/hyundai/certification.png')}
            hyundaiLightSrc={() => import('@di-shared/assets/img/visual/hyundai/certification.png')}
            hyundaiDarkSrc={() => import('@di-shared/assets/img/visual/hyundai/certification.png')}
            genesisLightSrc={() => import('@di-shared/assets/img/visual/genesis/certification.png')}
            genesisDarkSrc={() => import('@di-shared/assets/img/visual/genesis/certification.png')}
          />
        </div>
        <h3 className="certification_intro_title">{t('T20253')}</h3>
        <p className="certification_intro_desc">{t('T20254')}</p>
        <ul className="certification_target_list">
          <li className="certification_target_item">
            <span className="ic ic_check_20px"></span>
            <span className="certification_target_text">{t('T20256')}</span>
          </li>
        </ul>
        <div className="certification_upgrade">
          <div className="certification_upgrade_imgbox">
            <ImageSelector
              className="certification_upgrade_img"
              alt="certification_upgrade_img"
              kiaLightSrc={() => import('@di-shared/assets/img/car_management/hyundai/certification_upgrade.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/car_management/hyundai/certification_upgrade.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/car_management/hyundai/certification_upgrade.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/car_management/hyundai/certification_upgrade.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/car_management/genesis/certification_upgrade.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/car_management/genesis/certification_upgrade.png')}
            />
          </div>
          <div className="certification_upgrade_tip">
            <strong className="upgrade_tip_title">{t('T20257')}</strong>

            <ul className="section_bullet_list body_small_r">
              <li className="section_bullet_item">{t('T20258')}</li>
              <li className="section_bullet_item">{t('T20259')}</li>
              <li className="section_bullet_item">{t('T20260')}</li>
              <li className="section_bullet_item">{t('T20261')}</li>
            </ul>
          </div>
        </div>
      </section>
      <div className="divider divider_thick"></div>
      <section className="section">
        <h3 className="certification_intro_title">{t('T20262')}</h3>
        <DiagCpoGuideDetail />
      </section>
    </>
  );
}

function DiagCpoGuideDetail() {
  const {t} = useInferableTranslation();
  const [tab, setTab] = useState<'diag' | 'safeDriving'>('diag');

  return (
    <>
      <div
        className="tabbar type_brick"
        role="tablist"
      >
        <button
          type="button"
          className={clsx('tabbar_item body_medium_b', {
            'is-selected': tab === 'diag',
          })}
          onClick={() => setTab('diag')}
          id="diag_tab"
          role="tab"
          aria-selected={tab === 'diag'}
          aria-controls="diag_tabpanel"
          tabIndex={tab === 'diag' ? 0 : -1}
        >
          {t('T20263')}
        </button>
        <button
          type="button"
          className={clsx('tabbar_item body_medium_b', {
            'is-selected': tab === 'safeDriving',
          })}
          onClick={() => setTab('safeDriving')}
          id="safeDriving_tab"
          role="tab"
          aria-selected={tab === 'safeDriving'}
          aria-controls="safeDriving_tabpanel"
          tabIndex={tab === 'safeDriving' ? 0 : -1}
        >
          {t('T20246')}
        </button>
      </div>

      {tab === 'diag' && (
        <div
          className="tab_content"
          id="diag_tabpanel"
          aria-labelledby="diag_tab"
        >
          <strong className="certification_intro_title">{t('T20264')}</strong>
          <p className="certification_intro_desc">{t('T20265')}</p>
          <ul className="certification_detail_list">
            <li className="certification_detail_item">
              <div className="certification_detail_icon">
                <span className="ic ic_service_20px"></span>
              </div>
              <div className="certification_detail_info">
                <strong className="certification_detail_title">{t('T20266')}</strong>
                <span className="certification_detail_desc">{t('T20267')}</span>
              </div>
            </li>
            <li className="certification_detail_item">
              <div className="certification_detail_icon">
                <span className="ic ic_warning_light_20px"></span>
              </div>
              <div className="certification_detail_info">
                <strong className="certification_detail_title">{t('T20268')}</strong>
                <span className="certification_detail_desc">{t('T20269')}</span>
              </div>
            </li>
            <li className="certification_detail_item">
              <div className="certification_detail_icon">
                <span className="ic ic_cafe_20px"></span>
              </div>
              <div className="certification_detail_info">
                <strong className="certification_detail_title">{t('T20270')}</strong>
                <span className="certification_detail_desc">{t('T20271')}</span>
              </div>
            </li>
          </ul>
        </div>
      )}

      {tab === 'safeDriving' && (
        <div
          className="tab_content"
          id="safeDriving_tabpanel"
          aria-labelledby="safeDriving_tab"
        >
          <ul className="certification_detail_list">
            <li className="certification_detail_item">
              <div className="certification_detail_icon">
                <span className="ic ic_fuel_efficiency_20px"></span>
              </div>
              <div className="certification_detail_info">
                <strong className="certification_detail_title">{t('T20045')}</strong>
                <span className="certification_detail_desc">{t('T20272')}</span>
              </div>
            </li>
            <li className="certification_detail_item">
              <div className="certification_detail_icon">
                <span className="ic ic_layer_map_20px"></span>
              </div>
              <div className="certification_detail_info">
                <strong className="certification_detail_title">{t('T20273')}</strong>
                <span
                  className="certification_detail_desc"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  {t('T20274')}
                </span>
              </div>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default CpoGuide;
